import React from "react";
import "../Mission/Mission.css";
// import image from "../Assets/bg8.jpg";

function Mission() {
  // const gif1 = "https://i.giphy.com/media/v1.Y2lkPTc5MGI3NjExNTlyaXAwMmN2Y3cxMTJ1ejRvN2UzdGRhaTJiMDI0NzU0ZnNoY2R2cCZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/erpK9eBr5709v7uidI/giphy.gif";
  
  return (
    <>
      <div className="mission-vision">

        <div className="mission">
          <h1 >
            {" "}
            VISION
          </h1>
          <div className="row">
            <div className="col-2">
              {" "}
              <p>
                To be a leader in the field of Aerosol based Pharmaceuticals,
                with a strong dependence on sound business ethics coupled with a
                very high esteem for the people and shareholders along with a
                belief in traditional values, reliance on innovative technology
                and modern management concepts.
              </p>
            </div>
            {/* <div className="col-1">
              <img src={image} alt="" className="mission-image"/>
            </div> */}
          </div>
        </div>


        <div className="mission">
          <h1>
            {" "}
            MISSION
          </h1>
          <div className="row">
            {/* <div className="col-1">
              <img src={gif1} alt="" className="mission-image-gif"/>
            </div> */}
            <div className="col-2">
              {" "}
              <p>
                Create a conducive environment such that a dynamic group of
                people can harmoniously blend to form a TEAM that can attain
                collective excellence and record a brilliant achievement in the
                field of Aerosol based Pharmaceuticals. Manufacture & market
                products & services that reflect absolute Quality and result in
                “Total Customer Satisfaction”. Achieve excellence in growth
                through innovation and attain a good ‘corporate citizen’ status.
                We understand the value of life. We strive to serve mankind
                across the globe in a modest way by offering “Breather for Life”
                -a range of solutions to Respiratory Disorders for a healthier
                life. Our State-of -the -art manufacturing facility at Vapi,
                Gujarat, India has been set up towards the achievement of this
                Mission.
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
export default Mission;
